import { Region } from '../../user-dashboard/shared/region.model';

export class Report {

  public id: string;
  public name: string;
  public powerBiId: string;
  public assignedRegions: Region[];
  public homeReport: boolean;

  static fromDto(d: any): Report {
    if (!d) {
      return null;
    }

    const report = new Report();

    report.id = d.id;
    report.name = d.name;
    report.powerBiId = d.power_bi_id;
    report.assignedRegions = d.assigned_regions ? d.assigned_regions.map(r => Region.fromDto(r)) : null;
    report.homeReport = d.home_report;

    return report;
  }

  static toDto(report: Report): any {
    if (!report) {
      return null;
    }

    return {
      id: report.id,
      name: report.name,
      power_bi_id: report.powerBiId,
      assigned_regions: report.assignedRegions ? report.assignedRegions.map(r => Region.toDto(r)) : null,
      home_report: report.homeReport
    };
  }
}
